"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserChrome = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _designSystem = require("@storybook/design-system");

var _theming = require("@storybook/theming");

var _styles = require("./shared/styles");

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Frame = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qf1zff3"
} : {
  target: "e1qf1zff3",
  label: "Frame"
})("display:block;background:", function (props) {
  return props.inverse ? 'rgb(29 31 36 / 80%)' : '#efefef';
}, ";border:1px solid ", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';
}, ";border-radius:4px;overflow:hidden;box-shadow:0px 1px 3px 0px rgba(0, 0, 0, 0.1),0px 10px 20px 0px rgba(0, 0, 0, 0.1),0px 20px 40px 0px rgba(0, 0, 0, 0.05),0px 40px 30px 0px rgba(0, 0, 0, 0.05);");
var AddressBar = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qf1zff2"
} : {
  target: "e1qf1zff2",
  label: "AddressBar"
})("border-bottom:1px solid ", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';
}, ";height:15px;display:flex;align-items:center;justify-content:space-between;padding:0 6px;position:relative;");
var Address = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qf1zff1"
} : {
  target: "e1qf1zff1",
  label: "Address"
})("background-color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';
}, ";color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";border-radius:2.5px;font-size:6px;display:flex;align-items:center;justify-content:center;position:absolute;left:50%;transform:translateX(-50%);padding:2px 25px;line-height:1;svg{color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";display:block;width:5px;height:5px;margin-right:3px;}");

var Controls = function Controls(_ref) {
  var inverse = _ref.inverse,
      showControls = _ref.showControls;
  var clip1Id = (0, _reactDomInteractions.useId)();
  var clip2Id = (0, _reactDomInteractions.useId)();
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "61",
    height: "6",
    fill: "none",
    viewBox: "0 0 122 12"
  }, showControls && /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#".concat(clip1Id, ")")
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: inverse ? '#fff' : '#333',
    d: "M70.589 1.84a.429.429 0 010 .606l-3.126 3.126h10.108a.429.429 0 110 .857H67.463l3.126 3.126a.429.429 0 01-.606.606l-3.858-3.857a.429.429 0 010-.606l3.858-3.858a.429.429 0 01.606 0z"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#".concat(clip2Id, ")")
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: inverse ? '#fff' : '#333',
    d: "M95.411 1.84a.429.429 0 01.606 0l3.858 3.858a.428.428 0 010 .606l-3.858 3.857a.429.429 0 11-.606-.606l3.126-3.126H88.429a.429.429 0 110-.857h10.108L95.41 2.446a.429.429 0 010-.606z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: inverse ? '#fff' : '#333',
    d: "M116.078.428h-.079a5.571 5.571 0 105.494 6.5.428.428 0 10-.845-.143 4.709 4.709 0 01-4.649 3.928 4.714 4.714 0 010-9.428h.005a4.713 4.713 0 014.195 2.571h-1.628a.429.429 0 100 .857H121.142a.429.429 0 00.429-.428V1.713a.429.429 0 00-.858 0V3.03a5.565 5.565 0 00-4.635-2.6z"
  })), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "5",
    cy: "6",
    r: "5",
    fill: "#FC521F"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "23",
    cy: "6",
    r: "5",
    fill: "#FFAE00"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "41",
    cy: "6",
    r: "5",
    fill: "#66BF3C"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: clip1Id
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: inverse ? '#333' : '#fff',
    d: "M0 0H12V12H0z",
    transform: "translate(66)"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: clip2Id
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: inverse ? '#333' : '#fff',
    d: "M0 0H12V12H0z",
    transform: "translate(88)"
  }))));
};

var ToolBar = function ToolBar(_ref2) {
  var showControls = _ref2.showControls,
      inverse = _ref2.inverse,
      address = _ref2.address,
      _ref2$https = _ref2.https,
      https = _ref2$https === void 0 ? true : _ref2$https;
  return /*#__PURE__*/_react["default"].createElement(AddressBar, {
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement(Controls, {
    inverse: inverse,
    showControls: showControls
  }), showControls && /*#__PURE__*/_react["default"].createElement(Address, {
    inverse: inverse
  }, https && /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    icon: "lock"
  }), address));
};

var Website = (0, _theming.styled)("img", process.env.NODE_ENV === "production" ? {
  target: "e1qf1zff0"
} : {
  target: "e1qf1zff0",
  label: "Website"
})(process.env.NODE_ENV === "production" ? {
  name: "y301de",
  styles: "display:block;width:100%;height:auto"
} : {
  name: "y301de",
  styles: "display:block;width:100%;height:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var BrowserChrome = function BrowserChrome(_ref3) {
  var inverse = _ref3.inverse,
      showControls = _ref3.showControls,
      address = _ref3.address,
      image = _ref3.image,
      _ref3$https = _ref3.https,
      https = _ref3$https === void 0 ? true : _ref3$https;
  return /*#__PURE__*/_react["default"].createElement(Frame, {
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement(ToolBar, {
    inverse: inverse,
    address: address,
    https: https,
    showControls: showControls
  }), /*#__PURE__*/_react["default"].createElement(Website, {
    src: image.src,
    alt: "",
    width: image.width,
    height: image.height,
    loading: "lazy"
  }));
};

exports.BrowserChrome = BrowserChrome;